import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import Icon from '../../icon2/icon'
import NavButton from '../../button/navButton'
import ppmIcon from '../../../static/images/logo/ppm-simple.svg'

const LocateWrapper = styled.div`
  background-color: #f4f4f4;
`

const ButtonWrapper = styled.div`
  ${media.sm`
    margin: 0 0 0 20px;

    display: inline-block;
  `};
  ${media.md`
    margin: 0 0 0 50px;  
    display: inline-block;
  `};
`

const DigitalBusinessWrapper = styled.div`
  text-align: center;
  ${media.sm`
    text-align: left;
  `};
`
const AddressWrapper = styled.div`
  font-size: 12px;
  color: #3c4252;
  line-height: 1.5;
`

const PpmLogoWrapper = styled.div`
  border-right: solid 1px #b9b9b9;
  margin-right: 15px;
  padding-right: 15px;
`

const TextBlack = styled.p`
  margin: 0px;
  color: black;
  font-size: 12px;
`

const TextGray = styled.p`
  margin: 0px;
  color: #b9b9b9;
`

const MapButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  text-decoration: none;
  cursor: pointer;
  background-color: #3c4252;
  margin: 0 auto;
  &:hover {
    background-color: #40b4e4;
  }
`
const MapButtonWrapper = styled.div`
  background-color: transparent;
`

const MapButtonTitle = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  text-align: center;
  color: #ffffff;
`

function Locate() {
  return (
    <LocateWrapper className="container-fluid py-4">
      <div className="row">
        <div className="container">
          <div className="row">
            <div className="col-12 order-2 order-md-0 col-md mr-auto my-3 d-flex justify-content-center justify-content-md-start">
              <PpmLogoWrapper>
                <Icon width="51px" height="44px" to="/" icon={ppmIcon} />
              </PpmLogoWrapper>
              <TextGray className="align-self-center">
                Digital Business Developers
              </TextGray>
            </div>
            <div className="col-12 px-0 order-1 order-md-0 col-md-auto d-md-flex justify-content-between">
              <AddressWrapper className="align-self-center mx-4 my-3">
                <p className="mt-0 mb-1 text-center text-md-left">
                  Guipuzcoa y Mallorca esq, Ed. QPH, piso 4.
                </p>
                <p className="my-0 text-center text-md-left">Quito - Ecuador</p>
              </AddressWrapper>
            </div>
            <div className="col-12 px-0 order-1 order-md-0 col-md-auto d-md-flex justify-content-between">
              <ButtonWrapper className="align-self-center mx-4 my-3">
                <MapButton
                  href="https://www.google.com/maps/place/LOWE+DELTA/@-0.2097366,-78.4833047,21z/data=!4m5!3m4!1s0x91d59a0f73b56d3d:0x4e28309d5b6cf088!8m2!3d-0.2098194!4d-78.483194"
                  target="_blank"
                >
                  <MapButtonWrapper>
                    <MapButtonTitle>
                      {'Ver en el mapa'.toUpperCase()}
                    </MapButtonTitle>
                  </MapButtonWrapper>
                </MapButton>
              </ButtonWrapper>
            </div>
          </div>
        </div>
      </div>
    </LocateWrapper>
  )
}

export default Locate



// WEBPACK FOOTER //
// ./src/components/footer/locate/locate.js